import { Component, Input } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.css']
})
export class ModalErrorComponent {

  error: Response;
  
  @Input('ErrorResponse')
  set DoneLoading(error: Response) {
    if (error !== undefined){
      this.error = error;
      this.openErrorModal();
    }
  }
  
  constructor() { }
  
  closeErrorModal() {
    $('#errorModal').modal('hide')
  }
  
  openErrorModal(){
    $('#errorModal').modal('show')
  }


}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-error/modal-error.component.ts